import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
const StatsButtonClickedPieChart = observer(()=>{
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ } else {
        return /*#__PURE__*/ _jsx("div", {});
    }
});
export { StatsButtonClickedPieChart };
